const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

export const API_ROUTES = {
  BASE_URL  :`https://redalert-production-7dab.up.railway.app/`,
  LOGIN: `${API_BASE_URL}/auth/signin`,
  REGISTER: `${API_BASE_URL}/auth/signup`,
  CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
  HOSPITAL_PROFILE: `${API_BASE_URL}/hospital/profile`,
  UPDATE_PROFILE: `${API_BASE_URL}/hospital/update-profile`,
  REQUEST_HISTORY: `${API_BASE_URL}/request/hospital-requests`,
  BLOOD_REQUEST_DETAILS: (id) => `${API_BASE_URL}/request/blood-requests/${id}`,
  PENDING_REQUESTS: (hospitalId) => `${API_BASE_URL}/request/blood-request/pending?hospitalId=${hospitalId}`,
  FIND_DONORS: (requestId) => `${API_BASE_URL}/request/donors/find/${requestId}`,
  SEND_NOTIFICATION: `${API_BASE_URL}/notifications/send`,
  GET_HOSPITALS: `${API_BASE_URL}/hospitals`,
  GET_DONORS: `${API_BASE_URL}/donors`,
  CREATE_BLOOD_REQUEST: `${API_BASE_URL}/request/request-blood`,
  GET_NOTIFICATIONS: (hospitalId) => `${API_BASE_URL}/notifications/hospital/${hospitalId}`,
  MARK_NOTIFICATION_READ: (notificationId) => `${API_BASE_URL}/notifications/mark-read/${notificationId}`,
  DELETE_NOTIFICATION: (notificationId) => `${API_BASE_URL}/notifications/delete/${notificationId}`,
  SENT_NOTIFICATIONS: (hospitalId) => `${API_BASE_URL}/notifications/hospital/sentbox/${hospitalId}`,
  CREATE_POST: `${API_BASE_URL}/community/create`,
  GET_POSTS: `${API_BASE_URL}/community`,
  DELETE_POST: (id) => `${API_BASE_URL}/community/${id}`,
  SEARCH_DONORS: `${API_BASE_URL}/donors`,
  COMPLETE_REQUEST: (requestId) => `${API_BASE_URL}/request/complete/${requestId}`,
  CANCEL_REQUEST: (requestId) => `${API_BASE_URL}/request/cancel/${requestId}`,
  GET_HOSPITAL_REQUESTS:`${API_BASE_URL}/admin/hospital-requests`,
  APPROVE_HOSPITAL_REQUEST: (requestId) => `${API_BASE_URL}/admin/hospital-requests/${requestId}/approve`,
  REJECT_HOSPITAL_REQUEST: (requestId) => `${API_BASE_URL}/admin/hospital-requests/${requestId}/reject`,
  GET_BLOOD_DONORS:`${API_BASE_URL}/admin/blood-donors`,
  GET_REGISTERED_HOSPITALS:`${API_BASE_URL}/admin/hospitals-registered`,
  DOWNLOAD_DONOR_REPORT:`${API_BASE_URL}/admin/donor-report`,
  DELETE_DONOR: (donorId) => `${API_BASE_URL}/admin/delete-donor/${donorId}`,
  HOSPITAL_HISTORY: (hospitalId) => `${API_BASE_URL}/admin/hospital-history/${hospitalId}`,
  DELETE_HOSPITAL: (hospitalId) => `${API_BASE_URL}/admin/delete-hospital/${hospitalId}`,
  GET_DASHBOARD_STATS:`${API_BASE_URL}/admin/dashboard-stats`,
  GET_MONTHLY_REGISTRATION:`${API_BASE_URL}/admin/monthly-registrations`,
  GET_USER_DISTRIBUTION:`${API_BASE_URL}/admin/user-distribution`,
  ADMIN_REGISTER:`${API_BASE_URL}/admin/register`,
  ADMIN_LOGIN:`${API_BASE_URL}/admin/login`,


};